import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider, LayoutProvider } from '@forge/common';
import { RoleProvider } from './context/RoleContext';
import App from './App';
import { RootErrorBoundary } from './components/RootErrorBoundary';
import '@forge/common/dist/assets/index.css';
import '../styles.scss';

// In production, initialize Keycloak before rendering.
// For development, we render directly to allow work without auth.
const isDev = import.meta.env.DEV;

const bootstrap = async () => {
  if (!isDev) {
    const { initKeycloak } = await import('./auth/keycloak');
    const authenticated = await initKeycloak();
    if (!authenticated) {
      document.body.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif"><p>Signing in…</p></div>';
      return;
    }
  }

  const root = ReactDOM.createRoot(document.getElementById('root')!);
  root.render(
    <React.StrictMode>
      <RootErrorBoundary>
        <BrowserRouter>
          <LayoutProvider>
            <ToastProvider>
              <RoleProvider>
                <App />
              </RoleProvider>
            </ToastProvider>
          </LayoutProvider>
        </BrowserRouter>
      </RootErrorBoundary>
    </React.StrictMode>,
  );
}

bootstrap().catch((err) => {
  console.error('Failed to bootstrap application:', err);
  document.body.innerHTML =
    '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;gap:1rem;font-family:sans-serif;text-align:center;padding:2rem"><h1 style="font-size:1.25rem;margin:0">Unable to start</h1><p style="margin:0;color:#6b7280">The application failed to initialize. Please reload the page.</p><button type="button" onclick="window.location.reload()" style="padding:0.5rem 1rem;border-radius:0.375rem;border:none;background:#2563eb;color:#fff;cursor:pointer">Reload</button></div>';
});
